import * as React from 'react';
import {
    AdServerTagSideEnum,
    IAdServerTag,
    IAdServerTagTotals,
    IDemandSupplyTransaction
} from "@leap4/entities-discrepancy-common";
import {DynamicDatagrid, Grid, IDataGridProps, MuiDataGrid, Paper, Typography} from "@leap4/frontend";
import {EntitiesProperties} from "../../../../../utils/enums";
import {AdserverMetrics, TagsAndTotals} from "../interfaces";
import {useContext, useEffect, useState} from "react";
import {UserViewsContext} from "../../../../../contexts/userViewsContext";
import {generateColumn} from "../../../common/tableColumnsGenerator";
type GridColDef = MuiDataGrid.GridColDef;

export interface IAdServerRowConnectedTag {
    id: string
    name: string
    campaignId: string
    revenue: number,
    cost: number
    impressions: number,
    dataPoint: string
    adServer: string,
    metrics: IDemandSupplyTransaction[]
}

export interface IAdserverTagsTableProps extends Partial<IDataGridProps> {
    // metrics: Array<{ totals: IAdServerTagTotals, tag: IAdServerTag }>,
    metrics:TagsAndTotals[]
    loading: boolean,
    compareData?: AdserverMetrics,
}

export default function AdserverTagsTable({
                                              metrics,
                                              loading,
                                              refreshFunc,
                                              compareData,
                                          }: IAdserverTagsTableProps) {
    const {userViews} = useContext(UserViewsContext)
    const [columns, setColumns] = useState<GridColDef[]>([])
    const {
        CAMPAIGN_ID,
        NAME
    } = EntitiesProperties.NOT_NUMERIC
    useEffect(()=>{
        const userPresetColumns = userViews.activePreset.tableViews.map(view => generateColumn(view, compareData))
        const preConstantColumns = [NAME,CAMPAIGN_ID].map(view => generateColumn(view, compareData))
        setColumns([...preConstantColumns,...userPresetColumns])
    },[userViews, compareData])

    function createRowData(item: { totals: IAdServerTagTotals | any, tag: IAdServerTag }) {
        const {totals} = item;
        const profit = totals.revenue - totals.cost;
        return {
            id: item.tag._id,
            name: item.tag.name,
            campaignId: item.tag.campaignId,
            cost: totals.cost,
            revenue: totals.revenue,
            impressions: totals.impressions,
            requests: totals.requests,
            completion: totals.completion,
            profit,
            netCost: totals.netCost,
            profitPercent: (profit / totals.revenue) * 100,
            fillRate: ((totals?.impressions || 0) / (totals?.requests)) * 100,
            cpm: totals?.impressions === 0 ? 0 : totals?.cost / totals?.impressions * 1000,
            rpm: totals?.impressions === 0 ? 0 : totals?.revenue / totals?.impressions * 1000,
            vcr: totals?.impressions === 0 ? 0 : totals?.completion / totals?.impressions * 100,
            netProfit: totals?.netRevenue - totals?.netCost,
            ...totals
        }
    }

    const supplyRows = metrics?.filter(x => x.tag.side === AdServerTagSideEnum.SUPPLY).map(row => createRowData(row)).sort((a, b) => b.revenue > a.revenue ? 1 : -1) || [];
    const demandRows = metrics?.filter(x => x.tag.side === AdServerTagSideEnum.DEMAND).map(row => createRowData(row)).sort((a, b) => b.revenue > a.revenue ? 1 : -1) || [];

    return (
        <>
            <Grid container justifyContent={"space-around"} sm={12}>
                <Grid item xs={12}>
                    <Typography variant={"overline"}>Supply Tags</Typography>
                    <Paper elevation={5} style={{borderRadius:"16px", boxShadow: 'none'}}>
                        <DynamicDatagrid rows={supplyRows}
                                         columns={columns}
                                         loading={loading}
                                         loadError={false}
                                         refreshFunc={refreshFunc}
                                         pageSize={100}
                                         style={{minHeight: `75vh`, width: '100%'}}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <Grid container sm={12}>
                <Grid item xs={12}>
                    <Typography variant={"overline"}>Demand Tags</Typography>
                    <Paper elevation={5} style={{borderRadius:"16px", boxShadow: 'none'}}>
                        <DynamicDatagrid rows={demandRows}
                                         columns={columns}
                                         loading={loading}
                                         loadError={false}
                                         refreshFunc={refreshFunc}
                                         pageSize={100}
                                         style={{minHeight: `75vh`, width: '100%'}}
                        /></Paper>
                </Grid>
            </Grid>
        </>
    );
}
